import { useEffect, useState } from 'react'

import { Text, TextProps } from '@hhgtech/hhg-components/mantine'

import useStyles from './index.styles'

type Props = {
  text: string
  delay?: number
} & TextProps
export const TypeWritingEffect = ({
  text,
  delay = 30,
  className,
  ...textProps
}: Props) => {
  const [currentText, setCurrentText] = useState('')
  const [currentIndex, setCurrentIndex] = useState(0)
  const { classes, cx } = useStyles(undefined, {
    name: 'TypeWritingEffect',
  })

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentText((prevText) => prevText + text[currentIndex])
        setCurrentIndex((prevIndex) => prevIndex + 1)
      }, delay)

      return () => clearTimeout(timeout)
    }
  }, [currentIndex, delay, text])

  return (
    <Text className={cx(className, classes.root)} {...textProps}>
      {currentText}
    </Text>
  )
}
